module.exports = __webpack_public_path__ + "media/personas/bg-category-6982a34f.jpg";